<template>
  <div class="user-avatar" @click="toggleDropdown">
    <img 
      :src="userInfo && userInfo.avatar ? IMAGE_BASE_URL + userInfo.avatar : defaultAvatar" 
      :alt="userInfo && userInfo.nickname ? userInfo.nickname : '用户'" 
      class="avatar-image"
    >
    <span class="username">{{ userInfo && userInfo.nickname ? userInfo.nickname : '用户' }}</span>
    
    <!-- 下拉菜单 -->
    <div class="dropdown-menu" v-if="showDropdown">
      <div class="dropdown-item" @click="viewProfile">个人中心</div>
      <div class="dropdown-item" @click="confirmLogout">退出登录</div>
    </div>

    <!-- 退出确认弹窗 -->
    <message-box
      :visible="showLogoutConfirm"
      type="confirm"
      title="退出确认"
      message="确定要退出登录吗？"
      :showCancel="true"
      @confirm="handleLogout"
      @cancel="cancelLogout"
    />
  </div>
</template>

<script>
import { IMAGE_BASE_URL } from '../utils/constants';
import MessageBox from './MessageBox.vue';

export default {
  name: 'UserAvatar',
  components: {
    MessageBox
  },
  props: {
    userInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      showDropdown: false,
      defaultAvatar: 'https://picsum.photos/id/1/100/100', // 默认头像
      IMAGE_BASE_URL,
      showLogoutConfirm: false
    }
  },
  methods: {
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    viewProfile() {
      this.showDropdown = false;
      // 跳转到个人中心
      this.$emit('view-profile');
    },
    confirmLogout() {
      this.showDropdown = false;
      this.showLogoutConfirm = true;
    },
    cancelLogout() {
      this.showLogoutConfirm = false;
    },
    handleLogout() {
      // 关闭确认框
      this.showLogoutConfirm = false;
      
      // 清除本地存储的用户信息
      localStorage.removeItem('token');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('expireAt');
      localStorage.removeItem('userInfo');
      localStorage.removeItem('roles');
      
      // 通知父组件登出
      this.$emit('logout');
      
      // 跳转到登录页
      window.location.reload();
    },
    // 点击页面其他地方关闭下拉菜单
    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.showDropdown = false;
      }
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  }
}
</script>

<style scoped>
.user-avatar {
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;
}

.avatar-image {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.username {
  margin-left: 8px;
  font-size: 14px;
  color: #333;
  max-width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 5px;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  width: 120px;
  z-index: 100;
}

.dropdown-item {
  padding: 10px 15px;
  font-size: 14px;
  color: #333;
  transition: all 0.2s;
}

.dropdown-item:hover {
  background-color: #f5f5f5;
  color: #4169e1;
}

.dropdown-item:first-child {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.dropdown-item:last-child {
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}
</style> 